var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatspp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:whatsapp-icon",
    clipPath: "url(#clip0_207_16021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.682949 15.809C0.682199 18.4977 1.3902 21.1229 2.73645 23.4368L0.554199 31.3428L8.7082 29.2214C10.9635 30.4396 13.4904 31.078 16.0582 31.0781H16.0649C24.5418 31.0781 31.4422 24.2337 31.4458 15.8211C31.4474 11.7445 29.8489 7.91125 26.9447 5.02728C24.0409 2.14356 20.1791 0.554595 16.0643 0.552734C7.58645 0.552734 0.686574 7.39677 0.683074 15.809",
    fill: "url(#paint0_linear_207_16021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.13375 15.8035C0.132875 18.5889 0.86625 21.308 2.2605 23.7048L0 31.8942L8.44637 29.6967C10.7736 30.9558 13.3939 31.6196 16.0601 31.6206H16.067C24.848 31.6206 31.9963 24.53 32 15.8162C32.0015 11.5932 30.3455 7.62208 27.3375 4.63479C24.3291 1.64788 20.3291 0.00173643 16.067 0C7.2845 0 0.137375 7.08961 0.133875 15.8035H0.13375ZM5.16375 23.292L4.84837 22.7953C3.52262 20.7036 2.82288 18.2865 2.82387 15.8045C2.82675 8.56174 8.76725 2.66915 16.072 2.66915C19.6095 2.67064 22.934 4.03895 25.4345 6.52155C27.9349 9.0044 29.3108 12.3049 29.3099 15.8152C29.3066 23.058 23.366 28.9513 16.067 28.9513H16.0618C13.6851 28.9501 11.3542 28.3168 9.3215 27.12L8.83775 26.8353L3.8255 28.1393L5.16375 23.2919V23.292Z",
    fill: "url(#paint1_linear_207_16021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0849 9.19759C11.7867 8.53986 11.4728 8.52658 11.1892 8.51505C10.9569 8.50513 10.6914 8.50587 10.4262 8.50587C10.1607 8.50587 9.72932 8.60497 9.36469 9.00001C8.99969 9.39542 7.97119 10.351 7.97119 12.2944C7.97119 14.238 9.39782 16.1162 9.59669 16.38C9.79582 16.6433 12.3508 20.7591 16.3973 22.3425C19.7603 23.6584 20.4447 23.3967 21.1746 23.3307C21.9046 23.2649 23.5301 22.3754 23.8617 21.453C24.1936 20.5307 24.1936 19.7401 24.0941 19.5749C23.9946 19.4103 23.7291 19.3115 23.3309 19.114C22.9327 18.9164 20.9754 17.9608 20.6106 17.8289C20.2456 17.6972 19.9802 17.6315 19.7147 18.027C19.4492 18.4219 18.6868 19.3115 18.4544 19.5749C18.2223 19.839 17.9899 19.8718 17.5919 19.6742C17.1936 19.476 15.9114 19.0594 14.3903 17.7138C13.2068 16.6667 12.4078 15.3737 12.1756 14.9782C11.9433 14.5833 12.1507 14.3692 12.3503 14.1724C12.5292 13.9954 12.7486 13.7111 12.9478 13.4805C13.1463 13.2498 13.2126 13.0852 13.3453 12.8218C13.4782 12.5581 13.4117 12.3274 13.3123 12.1298C13.2126 11.9322 12.4389 9.97874 12.0849 9.19772",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_16021",
    x1: 16,
    y1: 31.3428,
    x2: 16,
    y2: 0.552734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_207_16021",
    x1: 16,
    y1: 31.8942,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_16021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatspp);
export default __webpack_public_path__ + "static/media/whatspp.4cfabf653582e788d4a4b501d631c490.svg";
export { ForwardRef as ReactComponent };